/**
 * The lab: technology NETBYTE builds for itself. Copy lives in every dictionary
 * as `lab.<slug>.kind`, `.description`, `.fact1…factN` and `.cta`; the name is a
 * proper noun and stays the same in every locale.
 *
 * `state` selects `state.<state>` ('training' or 'upcoming'). `art` is an
 * artwork key from `src/data/artwork.js`; `accent` tints the spotlight glow.
 * `link` is where the call to action leads.
 */
export const projects = [
  {
    slug: 'helix',
    name: 'Helix',
    state: 'training',
    art: 'blog_helix_part1',
    accent: '#2e66a8',
    facts: 3,
    link: '/blog/helix-language-model-part-1',
  },
  {
    slug: 'mira',
    name: 'Mira',
    state: 'upcoming',
    art: 'lab_mira',
    accent: '#c0602f',
    facts: 3,
    link: '/contact',
  },
];
